import React from 'react';
import {Button, Modal as AntModal, ModalProps, Row, Select} from 'antd';
import { MessageItem } from '../nf-message-modal';

interface IModal extends Omit<ModalProps, 'onOk' | 'onCancel'> {
    visible: boolean
    children: React.ReactNode;
    title: string;
    messages: MessageItem[];
    handleOk: (payerName?: string) => void;
    handleCancel: () => void;
}

const ModalConfirmationPayment: React.FC<IModal> = (props) => {   
      const [success, setSuccess] = React.useState<MessageItem[]>([]);
      const [payerName, setPayerName] = React.useState<string | null>(null);
    
      React.useEffect(() => {
        setSuccess(props.messages.filter((m) => !m.hasError));
      }, [props.messages]);     

    return (
        <AntModal
            data-testid="modal-form"
            destroyOnClose={true}
            forceRender
            title={props.title}
            open={props.visible}
            centered={true}
            onCancel={props.handleCancel}
            width={700}
            footer={[
                <Button key="back1" data-testid="modal-form-btn-cancel" style={{borderColor: '#de1010', color: '#de1010'}} onClick={props.handleCancel}>
                    Não
                </Button>,
                <Button key="back2" data-testid="modal-form-btn-cancel" style={{backgroundColor: '#298f46', color: '#fff'}} onClick={() => props.handleOk(payerName ? payerName : undefined)}>
                    Sim
                </Button>
            ]}
        >
            <Row>
                <p>Deseja fazer o pagamento agora?</p>
            </Row>
        </AntModal>
    );
};

export {ModalConfirmationPayment};
